// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Thicker-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: lightThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.photos_wrapper {
  width: 100%;
  position: relative;
}

.photos_dropdown>div:focus {
  outline: none !important;
}
.photos_dropdown_leaderboard>div:focus {
  outline: none !important;
}

.photos_header_div {
  width: 100%;
  position: fixed;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.photos_header_inner_div {
  /* width: 1443px; */
}
.leaderboard-data-list {
  display: flex;
  padding: 8px 0px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.leaderboard-data-list > label {
  font-family: "mediumThicker" !important;
  color: #000;
  font-size: clamp(14px, 2vw, 22px);
  font-style: normal;
  font-weight: 400;
  line-height: 126.6%;
  text-transform: capitalize;
}

.leaderboard-data-list:nth-child(odd) {
  background-color: rgba(196, 196, 196, 0.2);
}

.leaderboard-data-list:nth-child(even) {
  background-color: rgba(255, 255, 255, 1);
}
.rank-label {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(186, 30, 36, 1);
  border-radius: 50%;
  text-align: center;
  font-weight: bold;
}
.photos_cards_div_leaderboard {
  background-color: #262626;
  width: 100%;
  padding: 30px 5vw;
}

.photos_cards_div {
  background-color: rgb(210, 211, 212, 0.2);
    width: 100%;
  padding: 20px 5vw;
}
.photos_dropdown>p {
  color: black;
  font-family: "Thicker";
  font-size: clamp(14px, 2vw, 20px);
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 30px */
  margin-bottom: 20px;
  letter-spacing: 0.8px;
}
.photos_dropdown_leaderboard>p {
  color: white;
  font-family: "Thicker";
  font-size: clamp(14px, 2vw, 20px);
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 30px */
  margin-bottom: 20px;
  letter-spacing: 0.8px;
}

.photos_dropdown>div {
  width: 20%;
}
.photos_dropdown_leaderboard>div {
  width: 20%;
}


.photos-events-list {
  margin-top: 20px;
}
.photos-events-list > div {
  text-align: center;
  padding: 15px 0px;
  margin: 10px 0px;
  cursor: pointer;
  background: rgba(255, 255, 255, 1);
  color: black;
  font-family: "Thicker";
  font-size: clamp(14px, 2vw, 20px);
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-transform: capitalize;
}
.city-image-photo {
  padding: 15px;
  object-fit: cover;
  width: 100%;
  margin-bottom: 0px;
  height: 350px;
}


.leaderboard {
  padding: 5vw;
  background: #262626;
  display: flex;
  justify-content: space-between;
}

.leaderboard>div {
  width: 48%;
}

.leaderboard-head {
  background: transparent;
}

.leaderboard-head>p {
  color: #fff;
  font-family: Thicker;
  font-size: clamp(14px, 3vw, 20px);
  font-style: normal;
  font-weight: 500;
  padding: 14px 2vw;
  line-height: 150%;
  width: 45%;
  letter-spacing: 0.8px;
  background: #ba1e24;
  margin: 0px;
}

.leaderboard-data {
  background: #fff;
  /* padding: 0px 2vw 20px 2vw; */
}

.leaderboard-data-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 14px 2vw;
  background-color: rgba(210, 211, 212, 1);
}

.leaderboard-data-list {
  display: flex;
  padding: 14px 2vw;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.leaderboard-data-head>label {
  color: #ba1e24;
  font-family: Thicker;
  font-size: clamp(16px, 3vw, 24px);
  font-style: normal;
  font-weight: 500;
  line-height: 126.6%;
  text-transform: capitalize;
}



.dc_background_image{
  width: 100%;
}
@media screen and (max-width: 1350px) {
  .leaderboard-head>p {
    width: 55% !important;
  }

  .photos_dropdown>div {
    width: 40%;
  }
  .photos_dropdown_leaderboard>div {
    width: 40%;
  }
}

@media screen and (max-width: 1100px) {
  .leaderboard-head>p {
    width: 70% !important;
  }

  .photos_dropdown>div {
    width: 50% !important;
  }
  .photos_dropdown_leaderboard>div {
    width: 50% !important;
  }
}

@media screen and (max-width: 900px) {
  .leaderboard {
    display: block !important;
  }

  .photos_dropdown>div {
    transition: ease-in-out;
    width: 60% !important;
  }
  .photos_dropdown_leaderboard>div {
    transition: ease-in-out;
    width: 60% !important;
  }

  .leaderboard>div {
    width: 100% !important;
    margin-bottom: 30px;
  }

  .leaderboard-head>p {
    width: 50% !important;
  }
}

@media screen and (max-width: 900px) {
  .photos_dropdown>div {
    width: 100% !important;
  }
  .photos_dropdown_leaderboard>div {
    width: 100% !important;
  }
}

.photos-link {
  color: inherit !important;
  text-decoration: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/photos/photos.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4CAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;IACvC,WAAW;EACb,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;;AAGA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;;AAGA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;;;AAIA;EACE,WAAW;AACb;AACA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC","sourcesContent":["@font-face {\n  font-family: lightThicker;\n  src: url(../../assets/fonts/Thicker-Regular.otf);\n}\n\n.photos_wrapper {\n  width: 100%;\n  position: relative;\n}\n\n.photos_dropdown>div:focus {\n  outline: none !important;\n}\n.photos_dropdown_leaderboard>div:focus {\n  outline: none !important;\n}\n\n.photos_header_div {\n  width: 100%;\n  position: fixed;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n}\n\n.photos_header_inner_div {\n  /* width: 1443px; */\n}\n.leaderboard-data-list {\n  display: flex;\n  padding: 8px 0px;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.leaderboard-data-list > label {\n  font-family: \"mediumThicker\" !important;\n  color: #000;\n  font-size: clamp(14px, 2vw, 22px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 126.6%;\n  text-transform: capitalize;\n}\n\n.leaderboard-data-list:nth-child(odd) {\n  background-color: rgba(196, 196, 196, 0.2);\n}\n\n.leaderboard-data-list:nth-child(even) {\n  background-color: rgba(255, 255, 255, 1);\n}\n.rank-label {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(186, 30, 36, 1);\n  border-radius: 50%;\n  text-align: center;\n  font-weight: bold;\n}\n.photos_cards_div_leaderboard {\n  background-color: #262626;\n  width: 100%;\n  padding: 30px 5vw;\n}\n\n.photos_cards_div {\n  background-color: rgb(210, 211, 212, 0.2);\n    width: 100%;\n  padding: 20px 5vw;\n}\n.photos_dropdown>p {\n  color: black;\n  font-family: \"Thicker\";\n  font-size: clamp(14px, 2vw, 20px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  /* 30px */\n  margin-bottom: 20px;\n  letter-spacing: 0.8px;\n}\n.photos_dropdown_leaderboard>p {\n  color: white;\n  font-family: \"Thicker\";\n  font-size: clamp(14px, 2vw, 20px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  /* 30px */\n  margin-bottom: 20px;\n  letter-spacing: 0.8px;\n}\n\n.photos_dropdown>div {\n  width: 20%;\n}\n.photos_dropdown_leaderboard>div {\n  width: 20%;\n}\n\n\n.photos-events-list {\n  margin-top: 20px;\n}\n.photos-events-list > div {\n  text-align: center;\n  padding: 15px 0px;\n  margin: 10px 0px;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 1);\n  color: black;\n  font-family: \"Thicker\";\n  font-size: clamp(14px, 2vw, 20px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  text-transform: capitalize;\n}\n.city-image-photo {\n  padding: 15px;\n  object-fit: cover;\n  width: 100%;\n  margin-bottom: 0px;\n  height: 350px;\n}\n\n\n.leaderboard {\n  padding: 5vw;\n  background: #262626;\n  display: flex;\n  justify-content: space-between;\n}\n\n.leaderboard>div {\n  width: 48%;\n}\n\n.leaderboard-head {\n  background: transparent;\n}\n\n.leaderboard-head>p {\n  color: #fff;\n  font-family: Thicker;\n  font-size: clamp(14px, 3vw, 20px);\n  font-style: normal;\n  font-weight: 500;\n  padding: 14px 2vw;\n  line-height: 150%;\n  width: 45%;\n  letter-spacing: 0.8px;\n  background: #ba1e24;\n  margin: 0px;\n}\n\n.leaderboard-data {\n  background: #fff;\n  /* padding: 0px 2vw 20px 2vw; */\n}\n\n.leaderboard-data-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 14px 2vw;\n  background-color: rgba(210, 211, 212, 1);\n}\n\n.leaderboard-data-list {\n  display: flex;\n  padding: 14px 2vw;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.leaderboard-data-head>label {\n  color: #ba1e24;\n  font-family: Thicker;\n  font-size: clamp(16px, 3vw, 24px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 126.6%;\n  text-transform: capitalize;\n}\n\n\n\n.dc_background_image{\n  width: 100%;\n}\n@media screen and (max-width: 1350px) {\n  .leaderboard-head>p {\n    width: 55% !important;\n  }\n\n  .photos_dropdown>div {\n    width: 40%;\n  }\n  .photos_dropdown_leaderboard>div {\n    width: 40%;\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  .leaderboard-head>p {\n    width: 70% !important;\n  }\n\n  .photos_dropdown>div {\n    width: 50% !important;\n  }\n  .photos_dropdown_leaderboard>div {\n    width: 50% !important;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .leaderboard {\n    display: block !important;\n  }\n\n  .photos_dropdown>div {\n    transition: ease-in-out;\n    width: 60% !important;\n  }\n  .photos_dropdown_leaderboard>div {\n    transition: ease-in-out;\n    width: 60% !important;\n  }\n\n  .leaderboard>div {\n    width: 100% !important;\n    margin-bottom: 30px;\n  }\n\n  .leaderboard-head>p {\n    width: 50% !important;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .photos_dropdown>div {\n    width: 100% !important;\n  }\n  .photos_dropdown_leaderboard>div {\n    width: 100% !important;\n  }\n}\n\n.photos-link {\n  color: inherit !important;\n  text-decoration: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
